export const messages = {
  en: {
    adminProduct: {
      queryCondition: 'Query Conditions',
      inputProductName: 'Please enter product name',
      query: 'Query',
      onShelfProducts: 'On Shelf Products',
      productId: 'Product ID',
      productImage: 'Product Image',
      productGroup: 'Product Group',
      productName: 'Product Name',
      sales: 'Sales',
      stock: 'Stock',
      price: 'Price',
      sort: 'Sort',
      status: 'Status',
      shelfTime: 'Shelf Time',
      operation: 'Operation',
      view: 'View',
      delete: 'Delete'
    }
  },
  zh: {
    adminProduct: {
      queryCondition: '查询条件',
      inputProductName: '请输入商品名称',
      query: '查询',
      onShelfProducts: '上架商品',
      productId: '商品ID',
      productImage: '商品图片',
      productGroup: '商品分组',
      productName: '商品名称',
      sales: '销量',
      stock: '库存',
      price: '价格',
      sort: '排序',
      status: '状态',
      shelfTime: '上架时间',
      operation: '操作',
      view: '查看',
      delete: '删除'
    }
  }
}